import { currentUserResource } from '@jira/router-resources__current-user/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { isNinGlobalScopeEnrolmentEnabledResource } from '@atlassian/jira-router-resources-is-nin-global-scope-enrolment-enabled/src/index.tsx';
import {
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	issueNavigatorHydrationRelayResource,
	issueNavigatorHydrationRelayResourceBrowserOnly,
} from '@atlassian/jira-router-resources-issue-navigator/src/index.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { getAIContextPanelResources } from '@atlassian/jira-servicedesk-ai-context-panel-resources/src/services/index.tsx';
import { getDraftReplyPillsResource } from '@atlassian/jira-servicedesk-draft-reply-resources/src/index.tsx';

const getAIContextPanelResourcesWithCondition = () =>
	fg('empanada_nin_resource_audit_2025') ? [] : getAIContextPanelResources();

export const getCommonGlobalResources = () => [
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	resourceWithCondition2(
		() => fg('nin_request_hydrate_query_earlier') && !fg('render_jql_builder_in_ssr'),
		issueNavigatorHydrationRelayResourceBrowserOnly,
	),
	resourceWithCondition2(
		() => fg('render_jql_builder_in_ssr'),
		issueNavigatorHydrationRelayResource,
	),
	...getNavigationResources(),
	resourceWithCondition2(
		// not used, removing
		() => !fg('empanada_nin_resource_audit_2025'),
		navigationSidebarGlobalResource,
	),
	resourceWithCondition2(
		() => !fg('nin_remove_global_scope_enrolment'),
		isNinGlobalScopeEnrolmentEnabledResource,
	),
	resourceWithCondition2(() => fg('jfp-magma-current-user-resource'), currentUserResource),
	...getAIContextPanelResourcesWithCondition(),
	...getDraftReplyPillsResource(),
];
